<template lang="pug">
  v-slide-y-transition(mode="out-in")
    v-container(fluid)

      confirm(ref="deleteConfirm")

      v-btn(text, color="primary", class="right", @click="updateYear()") Actualizar año tarifas
      v-btn(text, color="primary", class="right", :to="`/accommodations/${accommodationId}/rooms/create`") Añadir nueva habitación

      v-data-table(:headers="tableHeaders", :items="rooms", disable-pagination, hide-default-footer, class="elevation-1")
        template(v-slot:item.options="{ item }")
          v-btn(:to="`/accommodations/${accommodationId}/rooms/${item.id}/duplicate`", text, icon, color="green")
            v-icon content_copy
          v-btn(:to="`/accommodations/${accommodationId}/rooms/${item.id}/edit`", text, icon, color="primary")
            v-icon edit
          v-btn(@click="handleDelete(item)", text, icon, color="red")
            v-icon delete
</template>

<style scoped>
</style>

<script>
export default {
  data() {
    return {
      loading: false,
      rooms: [],
      accommodationId: this.$route.params.accommodationId,
      tableHeaders: [
        {
          text: 'Nombre de la habitación',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Opciones',
          align: 'right',
          value: 'options',
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      api
        .get(`/accommodations/${this.accommodationId}/rooms`)
        .then((res) => {
          this.rooms = res.data;
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading = false;
        });
    },
    handleDelete(item) {
      this.$refs.deleteConfirm
        .open('Eliminar', '¿Estás seguro?')
        .then((confirm) => {
          if (confirm) {
            api
              .delete(
                `/accommodations/${this.accommodationId}/rooms/${item.id}`,
              )
              .then(() => {
                this.rooms.splice(this.rooms.indexOf(item), 1);
              })
              .catch(this.handleError);
          }
        });
    },
    updateYear() {
      this.loading = true;
      const year = new Date().getFullYear();
      let completed = 0;
      this.rooms.forEach((room) => {
        // eslint-disable-next-line no-param-reassign
        room.rates = room.rates.map((rate) => {
          const newRate = Object.assign({}, rate);
          if (newRate.fromDate) {
            const nFromDate = new Date(newRate.fromDate);
            nFromDate.setFullYear(year);
            newRate.fromDate = nFromDate.toISOString().split('T')[0];
          }
          if (newRate.toDate) {
            const nToDate = new Date(newRate.toDate);
            nToDate.setFullYear(year);
            newRate.toDate = nToDate.toISOString().split('T')[0];
          }
          return newRate;
        });
        api
          .put(`/accommodations/${this.accommodationId}/rooms/${room.id}`, room)
          .then((res) => {
            // eslint-disable-next-line no-console
            console.log(res);
          })
          .catch(this.handleError)
          .finally(() => {
            completed += 1;
            if (completed >= this.rooms.length) {
              this.loading = false;
            }
          });
      });
    },
    handleError(err) {
      // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Accommodations/AccommodationRooms.vue